import * as cnames from 'classnames'
import compact from 'lodash-es/compact'
import get from 'lodash-es/get'
import * as React from 'react'

import Tooltip from '../../tooltip'
import { IItemCard } from '../interface'

import * as styles from './lockupAudioTrackInfo.module.css'

interface IAttribute {
  name: string
  value: string
}

const LockupAudioTrackInfo = (props: IItemCard) => {
  const attributes = get(props, 'item.attributes', [])
  const bpm = get(
    attributes.filter(({ name }: IAttribute) => name === 'bpm'),
    '[0].value'
  )
  const initialLength = get(
    attributes.filter(({ name }: IAttribute) => name === 'length-audio'),
    '[0].value',
    ''
  )
  const additionalLength =
    get(
      attributes.filter(
        ({ name }: IAttribute) => name === 'length-audio-additional'
      ),
      '[0].value',
      ''
    ) || ''
  const additionalLengthArray = compact(additionalLength.split(','))
  const tracksNumber = additionalLengthArray.length + 1
  const tracksLengthsArray = compact([initialLength, ...additionalLengthArray])
  const tracksLengths = tracksLengthsArray.join(', ')

  return (
    <span
      className={cnames(styles.root, {
        [styles.grid]: props.viewType === 'grid'
      })}
    >
      <span className={styles.tracksArea}>
        Tracks{' '}
        {tracksLengthsArray.length > 1 ? (
          <Tooltip
            title={
              <span>
                <b>Tracks length:</b> {tracksLengths}
              </span>
            }
          >
            <span className={`${styles.bold} ${styles.dottedUnderline}`}>
              {tracksNumber}
            </span>
          </Tooltip>
        ) : (
          <span className={styles.bold}>{tracksNumber}</span>
        )}
      </span>
      <span className={bpm ? '' : styles.emptyAttribute}>
        BPM <span className={styles.bold}>{bpm ? bpm : '--'}</span>
      </span>
    </span>
  )
}

export default LockupAudioTrackInfo
